export default "__VITE_ASSET__Bc5nYr7E__"